import React from "react";
import VoucherRedemption from "./VoucherRedemption";

export default [
  {
    path: "/dashboard/vouchers",
    exact: true,
    component: () => <VoucherRedemption />
  }
];
